<template>
  <div v-loading="isLoading">
    <el-row class="mb-2">
      <el-col>
        <el-card>
              <span class="text-center">
                <strong> Seeder Manager</strong>
              </span>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-card class="mr-2">
          <div slot="header" class="clearfix">
            <strong>Usuários</strong>
          </div>
          <ul class="list-group">
            <li v-for="seeder in list" v-bind:class="{ 'active': isActive(seeder.id) }"
                class="list-group-item clickable" @click="form.seederSelected  = seeder">
              <span style="font-size: .8em ; font-weight: bold"> {{seeder.name}}</span>
            </li>
          </ul>
        </el-card>
      </el-col>
      <transition name="fade" mode="out-in">
        <el-col :span="20">
          <el-card class="box-card" v-if="isSelected">
            <div slot="header" class="clearfix">
              <strong> {{form.seederSelected.name}} </strong>
            </div>
            <el-row>
              <el-col :span="8">
             <el-checkbox-group v-model="form.centroCustoIds">
                  <div style="display: flex;flex-direction: column">
                    <el-checkbox v-for="grupo in listCentro"
                                 :label="grupo.id"
                                 :key="grupo.id">
                      {{grupo.nome}}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-col>
              <el-col :span="8">
                <el-checkbox-group v-model="form.gruposSelecionados">
                  <div style="display: flex;flex-direction: column">
                    <el-checkbox v-for="grupo in listGrupo"
                                 :label="grupo.id"
                                 :key="grupo.id">
                      {{grupo.nome}}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-col>
              <el-col :span="8">
                <div style="display: flex;flex-direction: column">
                  <el-checkbox v-model="form.atualiza_competencia">Competência Atual</el-checkbox>
                  <el-checkbox v-model="form.atualiza_default">Padrão</el-checkbox>
                  <el-button class="pull-right" type="primary" size="mini" @click="salvar">Aplicar</el-button>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card v-else>
            <el-alert
              title="Selecione um Seeder"
              type="info"
              :closable="false"
              show-icon>
            </el-alert>
          </el-card>
        </el-col>
      </transition>
    </el-row>
  </div>

</template>


<script>
  import {mapState, mapActions, mapGetters} from 'vuex'
  import {Message} from 'element-ui'
  import {trataErrors} from "../../domain/utils";

  export default {
    name: "Manager",
    data() {
      return {
        isLoading: false,
        value2: [],
        form: {},
        formInicial: {
          seederSelected: {},
          atualiza_competencia: false,
          atualiza_default: false,
          gruposSelecionados: [],
          centroCustoIds: []
        }
      }
    },
    computed: {
      ...mapState('CentroCusto', {
        listCentro: 'list'
      }),
      ...mapState('Seeder', ['list']),
      ...mapState('PerguntaGrupo', {
        listGrupo: state => state.list
      }),
      isSelected() {
        return this.form.seederSelected.hasOwnProperty('id')
      }
    },
    methods: {
      ...mapActions('Seeder', ['setList']),
      ...mapActions('PerguntaGrupo', {
        setListGrupo: 'setList'
      }),
      ...mapActions('CentroCusto', {
        setListCentro: 'setList'
      }),
      async salvar() {
        try {
          this.isLoading = true
          await axios.post(`${process.env.API_PATH}/seeder/update`, {...this.form})
          Message.success("Seeder Atualizado com sucesso.")
          this.form =  {... this.formInicial}

        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false

        }


      },
      isActive(id) {
        if (!this.isSelected) {
          return false
        }
        return id === this.form.seederSelected.id
      }
    },
    async mounted() {
      this.form =  {... this.formInicial}
      await this.setList()
      await this.setListGrupo()
      await this.setListCentro()
    }
  }
</script>

<style scoped>
  .el-checkbox + .el-checkbox {
    margin-left: 0px;
  }

  .active {
    border-color: #9933CC;
    background-color: #9933CC;
    color: #fff;
  }

  .grupo-title {
    font-weight: bold;
    font-size: .9em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Seeder/Manager.vue